import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { T } from "@/content/site";

export default function WhyUs() {
  const { t } = useLang();
  return (
    <section id="why-us" data-testid="why-us-section" className="relative bg-[#0F0F0F] py-[140px] md:py-[180px] border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-10 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-7">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline mb-8">
              <span className="inline-block w-8 h-px bg-[color:var(--sacrvm-gold)] align-middle mr-3" />
              {t(T.whyUs.overline)}
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
              className="font-serif text-white text-[42px] md:text-[72px] leading-[1] tracking-[-0.01em]"
            >
              {t(T.whyUs.title)}
            </motion.h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2">
          {T.whyUs.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (i % 5) * 0.05, ease: [0.19, 1, 0.22, 1] }}
              className="group flex items-baseline gap-6 py-7 border-t border-white/10 last:border-b hover:bg-white/[0.02] transition-colors"
            >
              <span className="font-serif text-[color:var(--sacrvm-gold)] text-[15px] tracking-[0.24em] w-14 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-serif text-white text-[22px] md:text-[28px] leading-[1.2] flex-1">
                {t(item)}
              </span>
              <span className="text-white/30 group-hover:text-[color:var(--sacrvm-gold)] transition-colors text-[18px]">→</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
